import * as PricingPlanActions from './../actions/pricing-plan.actions';
import { SimInfoResource, TechnicalError } from '@dch/products-business-logic';

export interface PricingPlanState {
  simInfo: SimInfoResource;
  isPending: boolean;
  error: TechnicalError;
}

export const initialState: PricingPlanState = {
  simInfo: null,
  isPending: false,
  error: null,
};

export function reducer(
  state: PricingPlanState = initialState,
  action: PricingPlanActions.Actions,
): PricingPlanState {
  switch (action.type) {
    case PricingPlanActions.GET_SIM_INFO:
      return {
        ...state,
        isPending: true,
        error: null,
      };
    case PricingPlanActions.GET_SIM_INFO_SUCCESS:
      return {
        ...state,
        simInfo: action.payload as SimInfoResource,
        isPending: false,
        error: null,
      };
    case PricingPlanActions.GET_SIM_INFO_FAILED:
      return {
        ...state,
        simInfo: null,
        error: action.payload as TechnicalError,
        isPending: false,
      };
    default:
      return state;
  }
}

export const getSimInfo = (state: PricingPlanState) => state.simInfo;
export const getTechnicalError = (state: PricingPlanState) => state.error;
export const getPending = (state: PricingPlanState) => state.isPending;
